import React, { useState, useEffect } from "react";
import AdminContent from "./AdminContent";
import ArticlesTab from "./ArticlesTab";
import ArticleTimeLine from "./ArticleTimeLine";
import SearchExampleStandardCustom from "./OptionsSearchInput";

function BlogSubBody() {
  //const [activeItem, setActiveItem] = useState("");

  return (
    <>
      {/*<SearchExampleStandardCustom></SearchExampleStandardCustom>*/}
      <ArticlesTab
      //articleGenre="blog"
      //articleType="general"
      //subArticleType="coding"
      //menuItems={["coding","living"]}
      >
      </ArticlesTab>
    </>
  );
}

export default BlogSubBody;
